export default __webpack_public_path__ + "static/media/gana_pala.447aa6b3.png";